import {
    Accordion,
    AccordionContent,
    AccordionHeader,
} from '@eventbrite/eds-accordion';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { Divider, Typography } from '@eventbrite/marmalade';
import React from 'react';
import { getTld } from '../../components/pricingAndPackagingUtils';
import { QUESTION_ANSWER } from './constants';
import styles from './FAQSection.module.scss';

export type FAQItemProps = {
    questionText: string | GenericLazyString;
    answer: Array<{
        heading: string | GenericLazyString;
        text: string | GenericLazyString;
        linkText?: string | GenericLazyString;
        link?: {
            [key: string]: string;
        };
    }>;
};

export const FAQItem: React.FunctionComponent<FAQItemProps> = (props) => {
    return (
        <div
            itemScope
            itemProp="mainEntity"
            itemType="https://schema.org/Question"
        >
            <Accordion>
                <AccordionHeader>
                    <div itemProp="name">
                        <Typography
                            as="h2"
                            variant="body-md-bold"
                            color="ui-800"
                        >
                            {props.questionText}
                        </Typography>
                    </div>
                </AccordionHeader>
                <AccordionContent>
                    <div
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                    >
                        <div className={styles.answerSection} itemProp="text">
                            {props.answer.map(
                                ({ heading, text, linkText, link }, index) => (
                                    <div
                                        className={styles.answerPara}
                                        key={'answer' + index.toString()}
                                    >
                                        {heading && (
                                            <Typography
                                                as="span"
                                                variant="body-md-bold"
                                                color="ui-700"
                                                className={styles.answerHeading}
                                            >
                                                {heading}
                                            </Typography>
                                        )}
                                        <Typography
                                            as="h2"
                                            variant="body-md"
                                            color="ui-700"
                                        >
                                            {text}
                                            {linkText && link ? (
                                                <a href={link[getTld()]}>
                                                    {linkText}
                                                </a>
                                            ) : null}
                                        </Typography>
                                    </div>
                                ),
                            )}
                        </div>
                    </div>
                </AccordionContent>
            </Accordion>
            <Divider />
        </div>
    );
};

export const FAQSection: React.FunctionComponent = () => {
    return (
        <div className={styles.sectionContainer}>
            <div className={styles.headerContainer}>
                <Typography
                    color="neutral-1000"
                    as="h1"
                    variant="heading-lg"
                    className={styles.headingTitle}
                >
                    {gettext('FAQs')}
                </Typography>
            </div>
            <>
                <section itemScope itemType="https://schema.org/FAQPage">
                    <div className={styles.sectionContent}>
                        {QUESTION_ANSWER.map(({ question, answer }, index) => (
                            <FAQItem
                                questionText={question}
                                answer={answer}
                                key={index.toString()}
                            />
                        ))}
                    </div>
                </section>
            </>
        </div>
    );
};
